<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span>安防设备管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item,index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "doorManagement",
  data() {
    return {
      infoList: [] //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(item) {
      bus.$emit("homePage", {
            type: "jump",
            path: item.url,
            title: item.title
          });
          
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
        {
          img:require("@/assets/beadhouse/newBodyinduction.png"),
          title:'红外感应器',
          text:'红外感应器管理',
          uid:1,
          url:'/LnfraredLnductor'
        },
        {
          img:require("@/assets/beadhouse/buttonlist.png"),
          title:'紧急呼叫器',
          text:'紧急呼叫器管理',
          uid:2,
          url:'/UrgencyBeeper'
        },
        {
          img:require("@/assets/beadhouse/AlertLight.png"),
          title:'烟雾报警器',
          text:'烟雾报警器管理',
          uid:3,
          url:'/SmogAlertor'
        },
        {
          img:require("@/assets/beadhouse/accessEvent.png"),
          title:'门窗感应器',
          text:'门窗感应器管理',
          uid:4,
          url:'/MagneticLnductor'
        },
        {
          img:require("@/assets/beadhouse/jinjihujiao.png"),
          title:'燃气报警器',
          text:'燃气报警器管理',
          uid:5,
          url:'/FuelAlertor'
        },
        {
          img:require("@/assets/beadhouse/foodmanage.png"),
          title:'水溢传感器',
          text:'水溢传感器管理',
          uid:6,
          url:'/overflowAlertor'
        },
        {
          img:require("@/assets/beadhouse/chuangdianlist.png"),
          title:'4G拐杖',
          text:'4G拐杖',
          uid:7,
          url:'/crutchList'
        },
        {
          img:require("@/assets/beadhouse/followlist.png"),
          title:'智能药盒',
          text:'智能药盒',
          uid:8,
          url:'/SmartPillboxList'
        },
        {
          img:require("@/assets/beadhouse/xungengshezhi.png"),
          title:'4G血糖仪',
          text:'4G血糖仪',
          uid:9,
          url:'/BloodSugarList'
        },
        {
          img:require("@/assets/beadhouse/hulixiangmu.png"),
          title:'4G血压计',
          text:'4G血压计',
          uid:10,
          url:'/BloodPressList'
        },
        {
          img:require("@/assets/beadhouse/watchlist.png"),
          title:'智能手环',
          text:'智能手环',
          uid:11,
          url:'/bracelet'
        },
        {
          uid: 12,
          text: "体征雷达",
          title: "体征监测雷达",
          img: require("@/assets/beadhouse/bodyinduction.png"),
          url: "/healthRadarList"
        },
        {
          uid: 13,
          text: "智能魔盒",
          text: "带网关功能的视频伴侣",
          img: require("@/assets/beadhouse/xungengbang.png"),
          url: "/MagicBox"
        },
      ];

    }
  },
  created() {
    this.getPageData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  height: 95%;
  padding: 0 0 20px 0;
  background: #fefefe;
  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;
    img {
      margin: 14px 12px;
    }
    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }
  .row_link {
    width: 95%;

    margin: 34px 35px;
    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;
      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }
      span {
        color: #666666;
      }
      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }
      a:hover {
        color: #333;
      }
    }
    .item:hover {
      border: 1px solid red;
    }
  }
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.clearfix {
  *zoom: 1;
}
</style>
